import en from './en.json'
import it from './it.json'

export const offersTranslations = {
	en,
	it
} as const
